import { h } from 'preact';

import { activeCue } from '../../lib/shorts';

// Muted autoplay is forced by mobile browsers, so subtitles are what make a clip
// watchable at all. Rendered as an overlay rather than a <track> so styling is
// consistent across browsers.
//
// White-on-translucent-black is hardcoded (not the usual text-body/bg-body
// dark-mode-adaptive classes) because this sits on top of a video, not the
// page background — it must stay legible over any frame regardless of the
// user's light/dark theme preference.
function ShortsSubtitles({ segments = [], currentTime = 0 }) {
    const cue = activeCue(segments, currentTime);
    if (!cue) {
        return null;
    }
    // 96px sits above the caption block, which is at 24px (clip.js) - a 72px
    // gap that clears a two-line clamped caption + creator name without
    // overlapping it. Both offsets add the safe-area inset because the shorts
    // wrapper is fullscreen (routes/frontpage/loggedIn.js and notLoggedIn.js),
    // so the clip reaches the physical screen edge on iPhones.
    return (
        <div
            class='position-absolute w-100 px-4 d-flex justify-content-center'
            style='bottom: calc(96px + env(safe-area-inset-bottom, 0px)); left: 0; pointer-events: none;'
        >
            <span
                class='text-white text-center rounded-3 px-2 py-1'
                style='background: rgba(0,0,0,0.55); font-size: 0.95rem; line-height: 1.35; max-width: 90%;'
            >
                {cue.text}
            </span>
        </div>
    );
}

export default ShortsSubtitles;
